import { createThemeService } from './ThemeService.impl';

/**
 * Global singleton instance of the ThemeService
 */
export const myThemeService = createThemeService();

/** The page content's theme, apart from the sidebar's (`content-theme` flag). */
export const myContentThemeService = createThemeService({
  storageKey: 'v5-content-theme-preference'
});

/** Public pages (a client's shortlist), apart from the app's own themes. */
export const myPublicPageThemeService = createThemeService({
  storageKey: 'v5-public-page-theme-preference',
  defaultPreference: 'system'
});
